import React from 'react'
import Header from '../Header'
import Sidebar from '../Sidebar'
import PageContent from './PageContent'

const Layout = () => {
  return (
    <div>
      <Header />
      <Sidebar />
      <PageContent />
    </div>
  )
}

export default Layout